var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Content"},[_c('DataAnalysisToolbar'),(_vm.isKeyDataBridge())?_c('DataBridge'):(_vm.isKeyHarmonization())?_c('GlobalHarmonizationSettings'):(_vm.isKeyCanDictionary())?_c('CanDictionary'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }